import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  createTimedEventProducts,
  getTagsInProduct,
  getTimedEventsProducts,
} from "../../services/timedEventsProductsService";

const AppliesOnProductsModal = ({ onClose }) => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { handleSubmit, setValue } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });

  const toast2 = useToast({
    position: "top",
    duration: 3000,
    status: "error",
  });

  const products = useSelector((state) => state.timedEventsProducts);

  useEffect(() => {
    dispatch(getTagsInProduct(id.id));
  }, [dispatch, id.id]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.timedEvents.edit_products")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.Products = values.Products?.map((el) => ({
                ProductId: el.ProductId,
              }));
              values.TimedEventId = id.id;
              values.UserId = localStorage.getItem("userId");
              if (
                values.Products === undefined ||
                values.Products?.length === 0
              ) {
                toast2({
                  description: t("validation.required"),
                });
              } else {
                dispatch(createTimedEventProducts(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t(
                        "pages.timedEvents.product_timed_event_created"
                      ),
                    });
                    dispatch(getTimedEventsProducts(id.id));
                    onClose();
                  });
              }
            })}
          >
            <Stack>
              <MultiSelect
                title={t("general.products")}
                data={
                  Array.isArray(products.tagsInProduct)
                    ? products.tagsInProduct.map((el) => ({
                        ...el,
                        label: `${el.ProductName} (${el.ProductSKURef})`,
                        value: el.ProductId,
                      }))
                    : []
                }
                isMulti={true}
                isRequired={true}
                onChange={(e) => setValue("Products", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("pages.inventory_item_details.apply")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={products.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={products.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AppliesOnProductsModal;
